import { useEffect, useRef } from 'react';

interface KeyboardCallbacks {
  onLabel1?: () => void;
  onLabel2?: () => void;
  onLabel3?: () => void;
  onUndo?: () => void;
  onPrev?: () => void;
  onNext?: () => void;
  onClassify?: () => void;
}

export function useKeyboardShortcuts(callbacks: KeyboardCallbacks, enabled: boolean): void {
  const callbacksRef = useRef(callbacks);
  callbacksRef.current = callbacks;

  useEffect(() => {
    if (!enabled) return;

    const handler = (e: KeyboardEvent) => {
      const tag = (document.activeElement?.tagName ?? '').toUpperCase();
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;

      switch (e.key) {
        case '1':
          callbacksRef.current.onLabel1?.();
          break;
        case '2':
          callbacksRef.current.onLabel2?.();
          break;
        case '3':
          callbacksRef.current.onLabel3?.();
          break;
        case 'U':
        case 'u':
          callbacksRef.current.onUndo?.();
          break;
        case 'ArrowLeft':
          callbacksRef.current.onPrev?.();
          break;
        case 'ArrowRight':
          callbacksRef.current.onNext?.();
          break;
        case 'C':
        case 'c':
          callbacksRef.current.onClassify?.();
          break;
      }
    };

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [enabled]);
}
